import { HrModuleType } from '../../../common/model/hr-module-type';

export class CodeTextUrlModel {
    baseUrl: string;
    port: HrModuleType;
}
